// extracted by mini-css-extract-plugin
module.exports = {"GarageDetails":"GarageDetails_GarageDetails__wXOLl","GarageIcon":"GarageDetails_GarageIcon__GPmCJ","GarageText":"GarageDetails_GarageText__8KwVF"};